import React from "react";
import PropTypes from "prop-types";
import { Accordion, AccordionSummary, AccordionDetails, Typography, Box } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKBadge from "components/MKBadge";

const FAQItem = ({ question, answer }) => (
  <Accordion
    elevation={0}
    sx={{
      borderRadius: "12px",
      mb: 2,
      border: "1px solid #e0e0e0",
      "&:before": { display: "none" },
    }}
  >
    <AccordionSummary
      expandIcon={<ExpandMoreIcon />}
      sx={{
        "& .MuiAccordionSummary-content": { my: 1.5 },
      }}
    >
      <Typography variant="h6" fontWeight="600">
        {question}
      </Typography>
    </AccordionSummary>
    <AccordionDetails>
      <Typography variant="body1" color="text.secondary">
        {answer}
      </Typography>
    </AccordionDetails>
  </Accordion>
);

FAQItem.propTypes = {
  question: PropTypes.string.isRequired,
  answer: PropTypes.string.isRequired,
};

const FAQ = () => {
  const faqs = [
    {
      question: "How do I get started?",
      answer:
        "Simply sign up, select your desired service, and our team will help you onboard seamlessly.",
    },
    {
      question: "Do you offer support?",
      answer: "Yes, we provide 24/7 customer support through chat, email, and phone.",
    },
    {
      question: "Are your services customizable?",
      answer:
        "Absolutely—our platform is flexible, and you can tailor features based on your needs.",
    },
    {
      question: "Is there any hidden cost?",
      answer: "No hidden fees. You only pay for what you select, with full pricing transparency.",
    },
  ];

  return (
    <MKBox component="section" py={2}>
      <Container>
        <Grid
          container
          item
          xs={12}
          lg={6}
          flexDirection="column"
          alignItems="center"
          sx={{ textAlign: "center", my: 6, mx: "auto", px: 0.75 }}
        >
          <MKBadge
            variant="contained"
            color="info"
            badgeContent="YOUR SHOW, OUR PROMISE"
            container
            sx={{ mb: 2 }}
          />
          <MKTypography variant="h2" fontWeight="bold">
            Frequently Asked Questions
          </MKTypography>
          <MKTypography variant="body1" color="text">
            Find instant clarity to your most common queries.
          </MKTypography>
        </Grid>
      </Container>
      <Container></Container>
      {faqs.map((faq, i) => (
        <FAQItem key={i} question={faq.question} answer={faq.answer} />
      ))}
    </MKBox>
  );
};

export default FAQ;
